import { createFeatureSelector } from '@ngrx/store';
import { AppState, SharedState } from '../models';

export const featureKey = 'shared';

export const selectShared = createFeatureSelector<AppState, SharedState>(featureKey);
